<template>
  <b-sidebar
    id="grouping-sidebar"
    title="Group By"
    backdrop
    shadow
    width="520px"
  >
    <div class="d-flex w-100 justify-content-end p-3">
      <b-button class="mr-1" @click="resetGrouping()">
        Reset
      </b-button>
      <b-button
        variant="success"
        v-show="
          filter.credit != null ||
          filter.gender != null ||
          filter.marital != null ||
          filter.outstanding != null
        "
        @click="addGroup()"
        >Add Group</b-button
      >
    </div>
    <div class="px-3 py-2 row">
      <div class="col-md-12 mb-2 d-flex flex-column">
        <label class="h5">Credit</label>
        <b-button-group>
          <b-button
            variant="outline-success"
            :class="filter.credit == 0 ? 'active' : ''"
            @click="filter.credit = 0"
            >>500.00</b-button
          >
          <b-button
            variant="outline-success"
            :class="filter.credit == 1 ? 'active' : ''"
            @click="filter.credit = 1"
            >50.00 - 500.00</b-button
          >
          <b-button
            variant="outline-success"
            :class="filter.credit == 2 ? 'active' : ''"
            @click="filter.credit = 2"
            >0 - 50.00</b-button
          >
        </b-button-group>
      </div>
      <div class="col-md-12 mb-2 d-flex flex-column">
        <label class="h5">Gender</label>
        <b-button-group>
          <b-button
            variant="outline-success"
            :class="filter.gender == 0 ? 'active' : ''"
            @click="filter.gender = 0"
            >Male</b-button
          >
          <b-button
            variant="outline-success"
            :class="filter.gender == 1 ? 'active' : ''"
            @click="filter.gender = 1"
            >Female</b-button
          >
        </b-button-group>
      </div>
      <div class="col-md-12 mb-2 d-flex flex-column">
        <label class="h5">Marital</label>
        <b-button-group>
          <b-button
            variant="outline-success"
            :class="filter.marital == 0 ? 'active' : ''"
            @click="filter.marital = 0"
            >Married</b-button
          >
          <b-button
            variant="outline-success"
            :class="filter.marital == 1 ? 'active' : ''"
            @click="filter.marital = 1"
            >Single</b-button
          >
        </b-button-group>
      </div>
      <div class="col-md-12 mb-2 d-flex flex-column">
        <label class="h5">Outstandings</label>
        <b-button-group>
          <b-button
            variant="outline-success"
            :class="filter.outstanding == 0 ? 'active' : ''"
            @click="filter.outstanding = 0"
            >>500.00</b-button
          >
          <b-button
            variant="outline-success"
            :class="filter.outstanding == 1 ? 'active' : ''"
            @click="filter.outstanding = 1"
            >50.00 - 500.00</b-button
          >
          <b-button
            variant="outline-success"
            :class="filter.outstanding == 2 ? 'active' : ''"
            @click="filter.outstanding = 2"
            >0 - 50.00</b-button
          >
        </b-button-group>
      </div>
    </div>
    <div class="px-3 row py-2" v-if="filterGroup.length > 0">
      <div class="col-md-12 mb-2 d-flex flex-column">
        <label class="h4">Saved Groups</label>
        <div class="d-flex" v-for="(item, index) in filterGroup" :key="index">
          <div class="col-11">
            <b-button
          pill
          variant="outline-danger w-100 my-2"
          size="lg"
          @click="applyGroup(item)"
          :class="selectedGroup == item.name ? 'active':''">{{ item.name }}</b-button>
          </div>
          <div class="col-1 d-flex align-items-center">
            <b-icon class="link" icon="x" @click="removeGroup(item)"></b-icon>
          </div>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>
<script>
import { openDB } from "idb";
import Swal from "sweetalert2";
export default {
  name: "sidebar",
  data() {
    return {
      filter: {
        credit: null,
        gender: null,
        marital: null,
        outstanding: null,
      },
      db: null,
      filterGroup: [],
      selectedGroup:""
    };
  },
  watch:{
    filter:{
      handler(val){
      this.$emit('groupEmit',this.filter);
    },
    deep:true
    }
  },
  methods: {
    resetGrouping(){
      this.filter = {
        credit: null,
        gender: null,
        marital: null,
        outstanding: null,
      };
    },
    applyGroup(data){
      console.log(data)
      this.filter.credit = data.filter.credit;
      this.filter.outstanding = data.filter.outstanding;
      this.filter.gender = data.filter.gender;
      this.filter.marital = data.filter.marital;
      this.selectedGroup = data.name;
    },
    removeGroup(data){
      this.filterGroup = this.filterGroup.filter(e=>(e !== data))
      this.addData(this.filterGroup);
    },
    async addData(data) {
      const tx = this.db.transaction("grouping", "readwrite");
      const store = tx.objectStore("grouping");
      store.put(data, "key");
      await tx.done;
    },
    async getData() {
      const tx = this.db.transaction("grouping", "readwrite");
      const store = tx.objectStore("grouping");
      const res = store.get("key");
      await tx.done;
      return res;
    },
    async addGroup() {
      let obj = {};
      let array = [];
      await Swal.fire({
        title: "Enter Grouping Name",
        input: "text",
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Add",
        showLoaderOnConfirm: true,
        preConfirm: (name) => {
          obj = {
            name: name,
            filter: this.filter,
          };
          this.filterGroup.push(obj);
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("Group added!", "success");
        }
      });

      this.addData(this.filterGroup);
    },
  },
  async mounted() {
    this.db = await openDB(this.$store.state.userName+"_member_grouping", 1, {
      upgrade(db, oldVersion, newVersion, transaction, event) {
        console.log("grouping created");
        db.createObjectStore("grouping");
      },
    });
    this.filterGroup = (await this.getData()) ?? [];
  },
};
</script>
